import React from "react";
import ReactPlayer from "react-player";

interface VideoPlayerProps {
  url: string;
  playing?: boolean;
  loop?: boolean;
  onClick?: any;
  videoClassName?: string;
  iconClassName?: string;
  playIcon?: string;
  thumbNailIcon?: string;
  thumbnailClassName?: string;
  controls?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  url,
  playing,
  loop,
  videoClassName,
  iconClassName,
  thumbnailClassName,
  onClick,
  playIcon,
  thumbNailIcon,
  controls,
}) => {
  return (
    <ReactPlayer
      url={url}
      config={{ file: { attributes: { controlsList: "nodownload" } } }}
      onContextMenu={(e: { preventDefault: () => any }) => e.preventDefault()}
      playing={playing}
      controls={controls}
      loop={loop}
      className={videoClassName}
      playIcon={<img src={playIcon} alt="Play" className={iconClassName} />}
      onClick={onClick}
      light={
        <img
          alt="Thumbnail"
          src={thumbNailIcon}
          className={thumbnailClassName}
        />
      }
    />
  );
};

export default VideoPlayer;
